import { Point, Rectangle } from "../primitives"
import { Format } from "./format"

/**
 * @memberOf Tee.Chart
 * @class Controls how to zoom chart axes by mouse or touch drag.
 * @param {Tee.Chart} chart The parent chart this zoom object belongs to.
 */
export class Zoom {
	constructor(chart) {
		this.chart = chart
		this.active = false
		this.enabled = true
		this.done = false
		this.touching = false
		this.direction = "both"
		this.keepAspect = false
		this.mouseButton = 0
		this.wheel = { enabled: false, factor: 1 }

		this.old = null
		this._rect = new Rectangle()

		this.format = new Format(chart)
		this.format.fill = "rgba(255,255,255,0.5)"
		this.format.stroke.fill = "darkgray"
		this.format.stroke.size = 2
	}

	change(pos) {
		if (!this.old) {
			this.old = new Point(0, 0)
		}

		const old = this.chart.oldPos

		this.old.x = pos.x - old.x

		if (this.keepAspect) {
			const chartRect = this.chart.chartRect
			this.old.y = this.old.x * (chartRect.height / chartRect.width)
		} else {
			this.old.y = pos.y - old.y
		}
	}

	_check() {
		const chartRect = this.chart.chartRect
		const direction = this.direction
		const both = direction === "both"
		const r = this._rect

		r.set(chartRect.x, chartRect.y, chartRect.width, chartRect.height)

		if (this.old) {
			if (both || direction === "horizontal") {
				if (this.old.x < 0) {
					r.x = this.chart.oldPos.x + this.old.x
					r.width = -this.old.x
				} else {
					r.x = this.chart.oldPos.x
					r.width = this.old.x
				}
			}

			if (both || direction === "vertical") {
				if (this.old.y < 0) {
					r.y = this.chart.oldPos.y + this.old.y
					r.height = -this.old.y
				} else {
					r.y = this.chart.oldPos.y
					r.height = this.old.y
				}
			}
		}

		return r
	}

	draw() {
		this.format.rectangle(this._check())
	}

	apply() {
		if (!this.old) {
			return false
		}

		if (this.old.x < 0 || this.old.y < 0) {
			this.reset()

			if (this.onreset) {
				this.onreset()
			}
		} else {
			const r = this._check()

			if (r.width > 3 && r.height > 3) {
				const direction = this.direction
				const both = direction === "both"

				this.chart.axes.each(function () {
					if (this.horizontal) {
						if (both || direction === "horizontal") {
							this.calcMinMax(r.x, r.x + r.width)
						}
					} else if (both || direction === "vertical") {
						this.calcMinMax(r.y + r.height, r.y)
					}
				})

				return true
			}
		}

		return false
	}

	reset() {
		this.chart.axes.each(function () {
			this.automatic = true
		})
	}
}
